import React from "react";
import { RT } from "./reviewTokens";

const StarRow = ({ value = 0, size = 14, spacing = 1.5, style = {} }) => {
  const filled = Math.round(value);
  return (
    <span
      aria-label={`${Math.round(value * 10) / 10} out of 5 stars`}
      style={{
        display: "inline-flex",
        fontSize: `${size}px`,
        letterSpacing: `${spacing}px`,
        lineHeight: 1,
        ...style,
      }}
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <span
          key={n}
          aria-hidden="true"
          style={{ color: n <= filled ? RT.star : RT.starEmpty }}
        >
          ★
        </span>
      ))}
    </span>
  );
};

export default StarRow;
